import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

function Footer() {
  return (
    <Box
      sx={{
        backgroundColor: "#909090",
        color: "white",
        py: 1.5,
        padding: "5px",
      }}
    >
      <Typography
        variant="body2"
        color="#eee"
        align="center"
        className="footerText"
      >
        <Typography
          variant="body2"
          color="#eee"
          align="center"
          className="footerText"
        >
          @2025 All rights reserved. Wm Morrisons Supermarkets Limited
          <Typography
            sx={{
              display: "inline-block",
              float: "right",
              paddingRight: "1rem",
            }}
            component="span"
            variant="body2"
            color="#eee"
            align="right"
          >
            v5.1
          </Typography>
        </Typography>
      </Typography>
    </Box>
  );
}

export default Footer;
